import PayItemAllowance from '@/api/hr/pay-item-allowance'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayItemAllowance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayItemAllowance.store(data)
  },

  update(context, { id, ...data }) {
    return PayItemAllowance.update(id, data)
  },

  destroy(context, id) {
    return PayItemAllowance.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.allowance_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  }
}
